import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from 'src/app/core/services/auth.service';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';

@Injectable({
    providedIn: 'root'
})
export class LookupService extends BaseProvider {

    copies: any = [
        {
            value: 0,
            label: "0"
        },
        {
            value: 1,
            label: "1"
        },
        {
            value: 2,
            label: "2"
        },
    ];

    //Birth Certificate
    certificateOwner: any = [];

    certificateVeteranOwner: any = [];

    locationType: any = [];

    relation: any = [];

    use: any = [];

    //Marriage Certificate

    relationMarriage: any = [];

    //Death Certificate//Death Certificate

    useDeath: any = [];

    relationDeath: any = [];
    relationDeathVeteran: any = [];

    //Stillborn Certificate

    useStillborn: any = [];

    //Work-Dept


    employerType: any = [
        {
            value: 1,
            label: "Con número patronal"
        },
        {
            value: 2,
            label: "Sin número patronal"
        },
    ];

    unemploymentRequestType: any = [
        {
            value: "Patrono",
            label: "Patrono"
        }
    ];


    cities: any = [];
    countries: any = [];
    states: any = [];


    transactionMenu: any = [];
    homeItems: any = [];
    expirationType: any = [
        {
            value: 1,
            label: "Status Does Not Expire"
        },
        {
            value: 2,
            label: "User Defined"
        },
        {
            value: 3,
            label: "Configured Expiration/Alerts"
        },
    ];

    timeType: any = [
        {
            value: 1,
            label: "Minutes"
        },
        {
            value: 2,
            label: "Hours"
        },
        {
            value: 3,
            label: "Days"
        },
        {
            value: 4,
            label: "Weeks"
        },
        {
            value: 5,
            label: "Months"
        },
        {
            value: 6,
            label: "Years"
        },
    ];



    constructor(
        public translate: TranslateService,
        public authService: AuthService,
        public globals: GlobalsService,
        public http: HttpClient,
        //public multiLanguageService: MultiLanguageService,

    ) {
        super();
        this.baseUrl = "lookup";
    }

    getLookups() {
        return new Promise<void>((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/lookups';

            this.http
                .get(this.url)
                .subscribe(
                    (data: any) => {
                        try {
                            const rawCities = JSON.parse(data[0] || '[]');
                            const rawCountries = JSON.parse(data[1] || '[]');
                            const rawStates = JSON.parse(data[2] || '[]');

                            const normalizeItem = (it: any) => ({
                                label: (it && it.label ? String(it.label).trim() : ''),
                                value: (it && it.value !== undefined && it.value !== null ? String(it.value).trim() : '')
                            });

                            this.cities = Array.isArray(rawCities) ? rawCities.map(normalizeItem) : [];
                            this.countries = Array.isArray(rawCountries) ? rawCountries.map(normalizeItem) : [];
                            this.states = Array.isArray(rawStates) ? rawStates.map(normalizeItem) : [];
                        } catch (e) {
                            this.cities = [];
                            this.countries = [];
                            this.states = [];
                        }
                        resolve(void 0); // Corrige el error de linter
                    },
                    err => { reject(err) }
                );
        });
    }


    setArrayLanguage() {
        this.expirationTypeLookups();
        this.timeTypeLookups();
        this.generateTransactionMenuItems();
        this.filterHomeItems();
        this.generateMainMenu();


        this.ownerLookups();
        this.locationTypeLookups();
        this.useLookups();
        this.relationMarriageLookups();
        this.useStillbornLookups();
        this.relationLookups();
        this.relationDeathLookups();
        this.relationDeathVeteranLookups();
        this.useDeathLookups();

        this.ownerVeteranLookups();
        this.employerTypeLookups();
        this.unemploymentTypeLookups();
    }

    generateTransactionMenuItems() {
        this
            .translate
            .get([
                'sequenceList.minutes', 'sequenceList.hours',
                'sequenceList.days', 'sequenceList.weeks',
                'sequenceList.months', 'sequenceList.years'])
            .subscribe(translations => {
                this.timeType = [
                    {
                        value: 1,
                        label: translations['sequenceList.minutes']
                    },
                    {
                        value: 2,
                        label: translations['sequenceList.hours']
                    },

                    {
                        value: 3,
                        label: translations['sequenceList.days']
                    },

                    {
                        value: 4,
                        label: translations['sequenceList.weeks']
                    },

                    {
                        value: 5,
                        label: translations['sequenceList.months']
                    },

                    {
                        value: 6,
                        label: translations['sequenceList.years']
                    }
                ];
            });
    }

    generateMainMenu() {
        this.translate.get(['menu.home', 'menu.transactions', 'menu.languages', 'menu.en', 'menu.es', 'menu.certifications', 'menu.messages', 'reports.certification-type-count',
            'reports.solicited-copies',
            'reports.transaction-date',
            'reports.status', 'reports.revenue',
            'menu.transactions', 'menu.reports'])
            .subscribe(translations => {
                var navigation = [
                    {
                        id: 'home',
                        title: translations['menu.home'],
                        translate: 'menu.home',
                        type: 'item',
                        url: "/", icon: "home", requiresAuth: false, roles: ["*"]
                    },

                    {
                        id: 'transactions',
                        title: translations['menu.transactions'],
                        translate: 'menu.transactions',
                        type: 'item',
                        url: "transactions", icon: "list", requiresAuth: true, roles: ["*"], policies: ["CanAddUserProcess"]
                    },


                    {
                        id: 'reports',
                        title: translations['menu.reports'],
                        translate: 'menu.reports',
                        url: "reports",
                        type: 'collapsable',
                        icon: "list",
                        requiresAuth: false,
                        //policies: ["CanAddUserProcess"],
                        roles: ["Admin", "Tecnico"],


                        children: [
                            {
                                id: 'transactionCount',
                                title: translations['reports.certification-type-count'],
                                translate: 'reports.certification-type-count',
                                type: 'item',
                                url: 'reports/certification/count',

                            },

                            {
                                id: 'transactionStatus',
                                title: translations['reports.status'],
                                translate: 'reports.status',
                                type: 'item',
                                url: 'reports/status',

                            },

                            // {
                            //     id       : 'chat',
                            //     title    : translations['menu.messages'],
                            //     translate: 'menu.messages',
                            //     type: 'item',
                            //     url: "chat", icon:"chat", requiresAuth: true, roles: ["*"]
                            // },
                            {
                                id: 'transactionRevenue',
                                title: translations['reports.revenue'],
                                translate: 'reports.revenue',
                                type: 'item',
                                url: 'reports/revenue',

                            },

                            {
                                id: 'transactionDate',
                                title: translations['reports.transaction-date'],
                                translate: 'reports.transaction-date',
                                type: 'item',
                                url: 'reports/transaction/date',

                            },

                            {
                                id: 'transactionCopies',
                                title: translations['reports.solicited-copies'],
                                translate: 'reports.solicited-copies',
                                type: 'item',
                                url: 'reports/solicited/copies',

                            },
                        ],
                    },
                    // {
                    //     id       : 'certifications',
                    //     title    : translations['menu.certifications'],
                    //     translate: 'menu.certifications',
                    //     type: 'item',
                    //     url: "certifications", icon:"stars", requiresAuth: true, roles: ["*"], policies: ["CanCreateCertifications"]
                    // },


                    // {
                    //     id       : 'chat',
                    //     title    : translations['menu.messages'],
                    //     translate: 'menu.messages',
                    //     type: 'item',
                    //     url: "chat", icon:"chat", requiresAuth: true, roles: ["*"]
                    // },
                    {
                        id: 'languages',
                        title: translations['menu.languages'],
                        translate: 'menu.languages',
                        icon: 'language',
                        type: 'collapsable',
                        roles: ["*"],
                        requiresAuth: false,

                        children: [
                            {
                                id: 'english',
                                title: translations['menu.en'],
                                translate: 'menu.english',
                                type: 'item',
                                url: '',
                                function: () => {
                                    this.selectLanguage('en');

                                    // window.location.reload();
                                }
                            },
                            {
                                id: 'spanish',
                                title: translations['menu.es'],
                                translate: 'menu.spanish',
                                type: 'item',
                                url: '',
                                function: () => {
                                    this.selectLanguage('es');

                                    // window.location.reload();
                                }
                            },
                        ],
                    },
                ];

                navigation = navigation.filter((menuItem: any) => {
                    var isInRole = false;
                    var hasAtLeastOne = (roles) => {
                        var hasRole = false;
                        if (this.authService.userProfile.roles) {
                            for (var i = 0; i < this.authService.userProfile.roles.length; ++i) {
                                if (menuItem.roles.includes(this.authService.userProfile.roles[i])) {
                                    hasRole = true;
                                }
                            }
                        }

                        return hasRole;
                    }

                    if (
                        menuItem.roles.includes('*')
                        ||
                        hasAtLeastOne(menuItem.roles)
                    ) {
                        isInRole = true;
                    }

                    return (this.authService.sessionActive == true || menuItem.requiresAuth == false)
                        &&
                        isInRole;
                });
            });
    }

    selectLanguage(ev) {
        this.authService.setLanguage(ev);
        this.authService.loadUserData();
        // this.multiLanguageService.trigger();
        // this.multiLanguageService.languageChangeEvent.next();

        this.setArrayLanguage();
    }

    expirationTypeLookups() {
        this.translate.get([
            'sequenceList.doesNotExpire',
            'sequenceList.userDefined',
            'sequenceList.configuredAlert'
        ])
            .subscribe(translations => {
                this.expirationType = [
                    {
                        value: 1,
                        label: translations['sequenceList.doesNotExpire']
                    },

                    {
                        value: 2,
                        label: translations['sequenceList.userDefined']
                    },

                    {
                        value: 3,
                        label: translations['sequenceList.configuredAlert']
                    }
                ];
            });
    }

    timeTypeLookups() {
        this
            .translate
            .get([
                'sequenceList.minutes', 'sequenceList.hours',
                'sequenceList.days', 'sequenceList.weeks',
                'sequenceList.months', 'sequenceList.years'])
            .subscribe(translations => {
                this.timeType = [
                    {
                        value: 1,
                        label: translations['sequenceList.minutes']
                    },
                    {
                        value: 2,
                        label: translations['sequenceList.hours']
                    },

                    {
                        value: 3,
                        label: translations['sequenceList.days']
                    },

                    {
                        value: 4,
                        label: translations['sequenceList.weeks']
                    },

                    {
                        value: 5,
                        label: translations['sequenceList.months']
                    },

                    {
                        value: 6,
                        label: translations['sequenceList.years']
                    }
                ];
            });
    }

    filterHomeItems() {
        this.translate.get(['home.users', 'home.usersContent', 'home.processTypes', 'home.processTypesContent',
            'home.roles', 'home.rolesContent', 'home.status', 'home.statusContent',
            'home.workflows', 'home.workflowsContent', 'home.transactions', 'home.transactionsContent'])
            .subscribe(translations => {
                this.homeItems = [
                    {
                        title: translations['home.users'],
                        content: translations['home.usersContent'],
                        url: "/admin/users",
                        roles: ["Admin"]
                    },
                    {
                        title: translations['home.processTypes'],
                        content: translations['home.processTypesContent'],
                        url: "/admin/process",
                        roles: ["Admin"]

                    },
                    {
                        title: translations['home.roles'],
                        content: translations['home.rolesContent'],
                        url: "/admin/process",
                        roles: ["Admin"]
                    },
                    {
                        title: translations['home.status'],
                        content: translations['home.statusContent'],
                        url: "/admin/process",
                        roles: ["Admin"]
                    },
                    {
                        title: translations['home.workflows'],
                        content: translations['home.workflowsContent'],
                        url: "/admin/process",
                        roles: ["Admin"]
                    },
                    {
                        title: translations['home.transactions'],
                        content: translations['home.transactionsContent'],
                        url: "/transactions",
                        roles: ["Proponente"]
                    }
                ];
            });
    }

    useDeathLookups() {
        this.translate.get(['certificateDeathUse.inheritance', 'certificateDeathUse.insurance',
            'certificateDeathUse.cause', 'certificateDeathUse.closeBank',
            'certificateDeathUse.record', 'certificateDeathUse.exhume',
            'certificateDeathUse.ssn', 'certificateDeathUse.procedure',
            'certificateDeathUse.other'])
            .subscribe(translations => {
                this.useDeath = [
                    { value: 1, label: translations['certificateDeathUse.inheritance'] },
                    { value: 2, label: translations['certificateDeathUse.insurance'] },
                    { value: 3, label: translations['certificateDeathUse.cause'] },
                    { value: 4, label: translations['certificateDeathUse.closeBank'] },
                    // { value: 5, label: translations['certificateDeathUse.record']},
                    // { value: 6, label: translations['certificateDeathUse.exhume']},
                    { value: 7, label: translations['certificateDeathUse.ssn'] },
                    { value: 8, label: translations['certificateDeathUse.procedure'] },

                    { value: 9, label: translations['certificateDeathUse.other'] },
                ];
            });
    }

    relationDeathLookups() {
        this.translate.get(['relation.deathChild', 'relation.deathPartner', 'relation.deathParent'])
            .subscribe(translations => {
                this.relationDeath = [
                    { value: 1, label: translations['relation.deathChild'] },
                    { value: 2, label: translations['relation.deathPartner'] },
                    { value: 3, label: translations['relation.deathParent'] },
                ];
            });
    }

    relationDeathVeteranLookups() {
        this.translate.get(['relation.deathChild', 'relation.deathPartner'])
            .subscribe(translations => {
                this.relationDeathVeteran = [
                    { value: 1, label: translations['relation.deathChild'] },
                    { value: 2, label: translations['relation.deathPartner'] },
                ];
            });
    }

    useStillbornLookups() {
        this.translate.get(['certificateStillbornUse.burial', 'certificateBirthUse.record', 'certificateStillbornUse.legalProcedure',
            'certificateStillbornUse.donation', 'certificateBirthUse.other'])
            .subscribe(translations => {
                this.useStillborn = [
                    { value: 1, label: translations['certificateStillbornUse.burial'] },
                    { value: 2, label: translations['certificateBirthUse.record'] },
                    { value: 3, label: translations['certificateStillbornUse.donation'] },
                    { value: 4, label: translations['certificateStillbornUse.legalProcedure'] },
                    { value: 5, label: translations['certificateBirthUse.other'] },
                ];
            });
    }

    relationMarriageLookups() {
        this.translate.get(['relation.contrayente', 'relation.parents'])
            .subscribe(translations => {
                this.relationMarriage = [
                    { value: 1, label: translations['relation.contrayente'] },
                    //{ value: 2, label: translations['relation.child']},
                    { value: 2, label: translations['relation.parents'] },
                ];
            });
    }

    useLookups() {
        this.translate.get(['certificateBirthUse.registration', 'certificateBirthUse.marriage', 'certificateBirthUse.benefits',
            'certificateBirthUse.heir', 'certificateBirthUse.request', 'certificateBirthUse.services',
            'certificateBirthUse.sports', 'certificateBirthUse.medicalPlan',
            'certificateBirthUse.passport', 'certificateBirthUse.retirement', 'certificateBirthUse.record', 'certificateBirthUse.other'])
            .subscribe(translations => {
                this.use = [
                    { value: 1, label: translations['certificateBirthUse.registration'] },
                    { value: 2, label: translations['certificateBirthUse.marriage'] },
                    { value: 3, label: translations['certificateBirthUse.benefits'] },
                    { value: 4, label: translations['certificateBirthUse.heir'] },
                    { value: 5, label: translations['certificateBirthUse.request'] },
                    { value: 6, label: translations['certificateBirthUse.services'] },
                    { value: 7, label: translations['certificateBirthUse.sports'] },
                    { value: 8, label: translations['certificateBirthUse.medicalPlan'] },
                    { value: 9, label: translations['certificateBirthUse.passport'] },
                    { value: 10, label: translations['certificateBirthUse.retirement'] },
                    { value: 11, label: translations['certificateBirthUse.record'] },
                    { value: 12, label: translations['certificateBirthUse.other'] },
                ];
            });
    }

    relationLookups() {
        this.translate.get(['relation.father', 'relation.mother'])
            .subscribe(translations => {
                this.relation = [
                    { value: 1, label: translations['relation.father'] },
                    { value: 2, label: translations['relation.mother'] },
                ];
            });
    }

    locationTypeLookups() {
        this.translate.get(['locationType.state', 'locationType.country'])
            .subscribe(translations => {
                this.locationType = [
                    { value: 1, label: translations['locationType.state'] },
                    { value: 2, label: translations['locationType.country'] },
                ];
            });
    }

    ownerLookups() {
        this.translate.get(['certificateOwner.child', 'certificateOwner.user', 'certificateOwner.parents'])
            .subscribe(translations => {
                this.certificateOwner = [
                    { value: 1, label: translations['certificateOwner.child'] },
                    { value: 2, label: translations['certificateOwner.user'] },
                    { value: 3, label: translations['certificateOwner.parents'] }
                ];
            });
    }

    ownerVeteranLookups() {
        this.translate.get(['certificateOwner.veteran', 'certificateOwner.veteranRelationship', 'certificateOwner.veteran'])
            .subscribe(translations => {
                this.certificateVeteranOwner = [
                    { value: 1, label: translations['certificateOwner.veteran'] },
                    { value: 2, label: translations['certificateOwner.veteranRelationship'] },
                ];
            });
    }

    unemploymentTypeLookups() {
        this.translate.get(['workDept.employer'])
            .subscribe(translations => {
                this.unemploymentRequestType = [
                    { value: 1, label: translations['workDept.employer'] },
                ];
            });
    }

    employerTypeLookups() {
        this.translate.get(['workDept.withEmpNum', 'workDept.withoutEmpNum'])
            .subscribe(translations => {
                this.employerType = [
                    { value: 1, label: translations['workDept.withEmpNum'] },
                    { value: 2, label: translations['workDept.withoutEmpNum'] },
                ];
            });
    }

    getLookupGetByLabel(label: string){
        return new Promise( (resolve, reject) => {
          this.url = `${this.globals.dataUrl}${this.baseUrl}/hub/${label}`;

            this.http
            .get(this.url)
            .subscribe(
                (data: any) => {
                    resolve(JSON.parse(data.Value));
                },
                err => {reject(err)}
            );
        });
      }
}
